import { Phone, Mail, MapPin } from "lucide-react";
import xpressLogo from "@/assets/xpress-logo.png";

const Footer = () => {
  return (
    <footer className="bg-foreground text-primary-foreground/70 py-14">
      <div className="max-w-7xl mx-auto section-padding">
        <div className="grid md:grid-cols-3 gap-10 mb-10">
          {/* Brand */}
          <div>
            <img src={xpressLogo} alt="XPress Promotion" className="h-10 object-contain mb-4 brightness-0 invert opacity-90" />
            <p className="text-sm leading-relaxed max-w-xs">
              Your full-service marketing agency for growing dental practices. Nearly two decades of results-driven strategy.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <p className="text-sm font-semibold text-primary-foreground uppercase tracking-wider mb-4">Quick Links</p>
            <div className="space-y-2.5">
              {["About", "Services", "Pricing", "Contact"].map((link) => (
                <a
                  key={link}
                  href={`https://www.xpresspromotion.com/${link.toLowerCase()}`}
                  className="block text-sm hover:text-primary-foreground transition-colors duration-200"
                >
                  {link}
                </a>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <p className="text-sm font-semibold text-primary-foreground uppercase tracking-wider mb-4">Get in Touch</p>
            <div className="space-y-3">
              <a href="tel:8776047112" className="flex items-center gap-2.5 text-sm hover:text-primary-foreground transition-colors">
                <Phone className="w-4 h-4 text-accent" /> (877) 604-7112
              </a>
              <a href="mailto:info@xpresspromotion.com" className="flex items-center gap-2.5 text-sm hover:text-primary-foreground transition-colors">
                <Mail className="w-4 h-4 text-accent" /> info@xpresspromotion.com
              </a>
              <a
                href="https://www.google.com/maps/place/XPress+Promotion/@38.8024437,-77.2138222,19.25z"
                className="flex items-start gap-2.5 text-sm hover:text-primary-foreground transition-colors"
              >
                <MapPin className="w-4 h-4 text-accent mt-0.5" /> 5508 Port Royal Rd, Springfield, VA 22151
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-primary-foreground/10 pt-6 text-center text-xs">
          © {new Date().getFullYear()} Xpress Inc. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
